const REFRESH_KEY = 'crm_auth_refresh'
const LEGACY_KEY = 'crm-auth'

function xorEncrypt(text: string, key: string): string {
  let result = ''
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length))
  }
  return btoa(result)
}

function xorDecrypt(encoded: string, key: string): string {
  try {
    const text = atob(encoded)
    let result = ''
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length))
    }
    return result
  } catch {
    return ''
  }
}

function storageKey(): string {
  const host =
    typeof globalThis.location !== 'undefined'
      ? globalThis.location.hostname
      : 'localhost'
  const base = navigator.userAgent + (host || 'localhost')
  let hash = 0
  for (let i = 0; i < base.length; i++) {
    hash = ((hash << 5) - hash) + base.charCodeAt(i)
    hash &= hash
  }
  return Math.abs(hash).toString(36).padStart(10, '0')
}

/** Refresh token em sessionStorage ofuscado — access token só em memória (Zustand). */
export function setSecureRefreshToken(token: string): void {
  try {
    sessionStorage.setItem(REFRESH_KEY, xorEncrypt(token, storageKey()))
  } catch {
    // ignore quota / private mode
  }
}

export function getSecureRefreshToken(): string | null {
  try {
    const stored = sessionStorage.getItem(REFRESH_KEY)
    if (!stored) return null
    const value = xorDecrypt(stored, storageKey())
    return value || null
  } catch {
    return null
  }
}

export function clearSecureRefreshToken(): void {
  try {
    sessionStorage.removeItem(REFRESH_KEY)
  } catch {
    // ignore
  }
}

/** Apaga refresh legado. A sessão fica só no cookie httpOnly. */
export function migrateLegacyAuthStorage(): void {
  try {
    localStorage.removeItem(LEGACY_KEY)
  } catch {
    // ignore
  }
  clearSecureRefreshToken()
}
